import { routeConstants } from '../../shared/constants';
import ForgotPassword from "./";

const route = {
  exact: true,
  path: routeConstants.FORGOT_PASSWORD.route,
  component: ForgotPassword
};

export default route